import { Injectable } from "@angular/core";
import firebase from "firebase";
import { ComingSoon } from "../data/ComingSoon";
import { Trailer } from "../data/Trailer";

@Injectable()
export class ComingSoonService {
  constructor() {}

  getComingSoon() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("comingSoon")
        .orderBy("addedAt", "desc")
        .get()
        .then(comingSoonSnapshot => {
          const comingSoonList = [];

          comingSoonSnapshot.forEach(doc => {
            const comingSoon = new ComingSoon();

            comingSoon.comingSoonId = doc.id;
            comingSoon.name = doc.data().name;
            comingSoon.picture = doc.data().picture;
            comingSoon.description = doc.data().description;
            comingSoon.releaseDate = doc.data().releaseDate;

            comingSoonList.push(comingSoon);
          });

          resolve({ comingSoonList: comingSoonList });
        });
    });

    return promise;
  }

  addToMyList(
    userId: string,
    comingSoonId: string,
    pushToken: string
  ) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("comingSoon")
        .doc(comingSoonId)
        .collection("waitingList")
        .add(
          {
            userId: userId,
            pushToken: pushToken,
            addedAt: firebase.firestore.FieldValue.serverTimestamp()
          }
        )
        .then(function(ref) {
          resolve({ newEpisodeId: ref.id });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addToWaitingList(
    userId: string,
    comingSoonId: string,
    pushToken: string
  ) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("comingSoon")
        .doc(comingSoonId)
        .collection("waitingList")
        .add(
          {
            userId: userId,
            pushToken: pushToken,
            addedAt: firebase.firestore.FieldValue.serverTimestamp()
          }
        )
        .then(function(ref) {
          resolve({ newEpisodeId: ref.id });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getTrailers() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("trailers")
        .orderBy("addedAt", "desc")
        .get()
        .then(trailersSnapshot => {
          const trailersList = [];

          trailersSnapshot.forEach(doc => {
            const trailer = new Trailer();

            trailer.trailerId = doc.id;
            trailer.name = doc.data().name;
            trailer.picture = doc.data().picture;
            trailer.description = doc.data().description;
            trailer.releaseDate = doc.data().releaseDate;
            trailer.videoUrl = doc.data().videoUrl;

            trailersList.push(trailer);
          });

          resolve({ trailersList: trailersList });
        });
    });

    return promise;
  }

  checkIfWaiting(comingSoonId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("comingSoon")
      .doc(comingSoonId)
      .collection("waitingList")
        .get()
        .then(snapshot => {
          let tokens = [];

          snapshot.forEach(doc => {
            tokens.push(doc.data());
          });

          resolve({ tokens: tokens });
        });
    });

    return promise;
  }

  trailerCheckIfWaiting(trailerId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("trailers")
      .doc(trailerId)
      .collection("waitingList")
        .get()
        .then(snapshot => {
          let tokens = [];

          snapshot.forEach(doc => {
            tokens.push(doc.data());
          });

          resolve({ tokens: tokens });
        });
    });

    return promise;
  }

  addToTrailerWaitingList(
    userId: string,
    trailerId: string,
    pushToken: string
  ) {
    console.log('---d-d--d-d-d--d-d-d-d--');
    console.log(trailerId)
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("trailers")
        .doc(trailerId)
        .collection("waitingList")
        .add(
          {
            pushToken: pushToken,
            userId: userId,
            addedAt: firebase.firestore.FieldValue.serverTimestamp()
          }
        )
        .then(function(ref) {
          resolve({ newEpisodeId: ref.id });

        })
        .catch(function(error) {
          reject(error);
          alert('failed');
          console.error(error)
        });
    });

    return promise;
  }

}



// WEBPACK FOOTER //
// ./src/services/ComingSoonService.ts